import { ThemingProps } from '@chakra-ui/react';
import { Icon } from '@whalar/ui/src/components/Icon/Icon';
import { Button } from 'ui-components';

import { EventProperties } from '../types';

export type FakeDoorButtonOptions = {
  action: string | null;
  eventProperties: EventProperties;
  onClick: (action: string, properties: EventProperties) => void;
};

export type FakeDoorButtonProps = {
  variant?: ThemingProps<'ButtonProps'>['variant'];
  className?: string;
  eventProperties?: EventProperties;
};

export const createFakeDoorButton = ({
  action,
  onClick,
}: FakeDoorButtonOptions) => {
  if (!action) return null;

  const FakeDoorButton: React.FC<FakeDoorButtonProps> = ({
    className,
    eventProperties = {},
    variant = 'tertiary',
  }) => {
    return (
      <Button
        className={className}
        leftIcon={<Icon name="Magic" />}
        onClick={() => onClick(action, eventProperties)}
        size="md"
        variant={variant}
      >
        {action}
      </Button>
    );
  };
  return FakeDoorButton;
};
